import { useTranslation } from '@/app/components/translations/Translation.tsx';
import React, { useContext } from 'react';
import styled from 'styled-components';
import type { CustomPillElementProps } from '@/app/common/filters/surfaces/bar/pills/types.ts';
import Pill from '@/app/common/components/Pill';
import { useSearchDealsPageData } from '@/app/components/search/searchDealsPageProvider.tsx';
import { ViewMode } from '@/app/common/viewModeUtils.ts';
import { SearchPageContext } from '@/app/components/search/components/SearchPageContainer/SearchPageContext.ts';
import { MaskIcon } from '@/app/common/icons/MaskIcon';

// The pill spaces its own parts tightly; an icon sitting beside the label wants more room.
const ViewModeLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;

export const ViewModePill = ({ isLoading, busy }: CustomPillElementProps) => {
  const { handleViewModeSwitch } = useSearchDealsPageData();
  const { listView } = useContext(SearchPageContext);
  const { t } = useTranslation();
  const viewMode = listView ? ViewMode.LIST : ViewMode.MAP;
  const viewMap = viewMode === ViewMode.LIST;
  const label = viewMap ? (
    <ViewModeLabel>
      <MaskIcon category="Location" name="icon-map" size={20} />
      {t('vacation.oss.map.view_map_short')}
    </ViewModeLabel>
  ) : (
    t('vacation.oss.map.view_list')
  );

  return (
    <Pill
      isLoading={isLoading}
      busy={busy}
      label={label}
      handleClick={handleViewModeSwitch}
      hasPopover={false}
      toggles={false}
      selected={false}
      isOpen={false}
      className="pill pill-view-mode"
    />
  );
};
